import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    Paper,
    Button,
    TextField
} from '@material-ui/core';
import { format } from "date-fns";
import { withStyles } from '@material-ui/core/styles';
import { getWithToken } from 'api/network';
import {
    setConfirmationModalState
} from 'store/actions';

const IntegrationsTab = ({
    classes,
    setConfirmationModalState
}) => {
    const exportSqlSchema = () => {
        onShowExportSchema();
    }

    const onShowExportSchema = () => {
        setConfirmationModalState({ // Open confirmation modal
            isModalOpen: true,
            handleConfirmation: () => {
                closeConfirmationModal();
                getSqlSchema();
            },
            handleCancellation: closeConfirmationModal,
            contentText: `You are about to export the Revue DB schema. Are you sure?`
        });
    }

    const closeConfirmationModal = () => {
        setConfirmationModalState({ isModalOpen: false });
    }

    function getTimestamp() {
        return format(new Date(), '_yyyy-MM-dd_HHmmss');
      }

    async function getSqlSchema() {
        const url = `/api/admin/Utilities/GetDbSqlScript`;
        const response = await getWithToken(url)
        downloadSqlFile(await response.blob());
     }

    function downloadSqlFile(data){
        const filename = `ReVUe_Schema_Export_${ getTimestamp() }.sql`;
        const datablob = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = datablob;
        link.download = filename;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    return (
        <Paper className={classes.tabRoot}> 
                <Button variant={'contained'}
                        color={'primary'}
                        style={{ marginRight: "16px"}}
                        onClick={() => exportSqlSchema()}>Export SQL Schema</Button>        
        </Paper>
    );
};
const styles = {
    tabRoot: {
        padding: '30px',
        // ToDo: temp width/height
        minHeight: '200px',
        minWidth: '400px'
    }
};

const mapStateToProps = (state) => ({
    
});

const mapDispatchToProps = (dispatch) => ({
    setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState))
});

export default compose(
    withRouter,
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(IntegrationsTab);